export default __webpack_public_path__ + "static/media/pdf.ca9bb696.jpg";